import { BillingApi, UpdateBilling } from '@/api';
import { ApiUtils } from '@/common/ApiUtils';

export class BillingService {
	constructor(private billingApi: BillingApi = new BillingApi()) {}

	public async getCurrentBilling(
		id: string | number,
	): Promise<{ billing?: UpdateBilling; errorMessage?: string }> {
		if (typeof id === 'string') id = parseInt(id, 10);
		try {
			const response = await this.billingApi.currentBilling(id);
			return { billing: response.data.data };
		} catch (e) {
			console.error('Error getting current billing by product id:', e);
			return ApiUtils.handleApiError(e, `Failed to fetch current billing by ID: ${id}`);
		}
	}
}
